import { useContext, useEffect } from 'react';

import Context from '../../Context';

interface TitleProps {
  children: string;
}

export const Title = ({ children }: TitleProps) => {
  const { setTitle } = useContext(Context);

  setTitle(children);

  useEffect(() => {
    return () => {
      setTitle('');
    };
  }, [setTitle]);

  return null;
};
